/* app/js/src/components/content-control/studio/content-control-studio/content-control-studio-timeline/content-control-studio-timeline-track-segment/content-control-studio-timeline-track-segment.component.scss */
:host {
  display: flex;
}
svg {
  min-height: 1px;
  position: relative;
}
/*# sourceMappingURL=content-control-studio-timeline-track-segment.component.css.map */
